import { useAccount } from "../features/accounts/hooks/useAccount";
import { AccountDetails } from "../features/accounts/components/AccountDetails";
import { ActionButtons } from "../features/accounts/components/ActionButtons";
import Alert from '../components/Alert';
import Loading from "../features/uiStatus/components/Loading";
import { pageShell } from "../styles/pageShell";

function AccountPage() {
    const { user, loading, error, handleLogout } = useAccount();

    const getRoleLabel = (role) => {
        const roleMap = {
            student: "生徒",
            teacher: "教師",
            admin: "管理者"
        };
        return roleMap[role] || role;
    };

    const getRoleIcon = (role) => {
        const iconMap = {
            student: "school",
            teacher: "person",
            admin: "admin_panel_settings"
        };
        return iconMap[role] || "person";
    };

    if (loading) return (
        <div className={pageShell.container}>
            <div className={pageShell.card}>
                <Loading isLoading />
            </div>
        </div>
    );
    if (error) return (
        <div className={pageShell.container}>
            <div className={pageShell.card}>
                <div className="flex min-h-[12.5rem] flex-1 items-center justify-center">
                    <Alert type="danger" message={error} />
                </div>
            </div>
        </div>
    );

    return (
        <div className={pageShell.container}>
            <div className={pageShell.header}>
                <h2 className={pageShell.title}>アカウント情報</h2>
                {user && (
                    <div className={pageShell.headerAside}>
                        <span className={pageShell.roleBadge}>
                            <span className={pageShell.badgeIcon}>
                                {getRoleIcon(user.role)}
                            </span>
                            {getRoleLabel(user.role)}
                        </span>
                    </div>
                )}
            </div>
            <div className={pageShell.card}>
                <AccountDetails user={user} />
                <ActionButtons onLogout={handleLogout} />
            </div>
        </div>
    );
}

export default AccountPage;
